document.addEventListener('DOMContentLoaded', () => {
  const blocks = document.querySelectorAll('.case-studies');

  blocks.forEach((block) => {
    const slides = block.querySelectorAll('.case-studies__slide');
    const dots = block.querySelectorAll('.case-studies__dot');
    const prevArrow = block.querySelector('.case-studies__arrow--prev');
    const nextArrow = block.querySelector('.case-studies__arrow--next');
    const topHeading = block.querySelector('.js-case-studies-top-heading');

    if (slides.length <= 1) {
      return;
    }

    let currentIndex = [...slides].findIndex((slide) => slide.classList.contains('is-active'));
    if (currentIndex < 0) {
      currentIndex = 0;
    }

    const goToSlide = (index) => {
      const clampedIndex = Math.max(0, Math.min(slides.length - 1, index));
      currentIndex = clampedIndex;

      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === clampedIndex);
      });

      if (topHeading) {
        topHeading.textContent = slides[clampedIndex].dataset.topHeading || '';
      }

      if (dots.length) {
        dots.forEach((dot, i) => {
          const isActive = i === clampedIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }
    };

    if (dots.length) {
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.getAttribute('data-slide') || '0', 10);
          goToSlide(index);
        });
      });
    }

    if (prevArrow) {
      prevArrow.addEventListener('click', () => {
        const newIndex = (currentIndex - 1 + slides.length) % slides.length;
        goToSlide(newIndex);
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', () => {
        const newIndex = (currentIndex + 1) % slides.length;
        goToSlide(newIndex);
      });
    }

    // Touch swipe support
    let touchStartX = 0;
    let touchStartY = 0;

    block.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });

    block.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;

      // Only treat as a horizontal swipe if horizontal movement exceeds 40px
      // and is greater than vertical movement (not a scroll)
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;

      if (dx < 0) {
        // Swipe left → next slide
        goToSlide((currentIndex + 1) % slides.length);
      } else {
        // Swipe right → previous slide
        goToSlide((currentIndex - 1 + slides.length) % slides.length);
      }
    }, { passive: true });
  });
});

